

































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import FileUploader from "@/components/FileUploader.vue";
import Page from "@/views/Page.vue";
import FamiliesMixin from "@/mixins/http/FamiliesMixin";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { Family } from "@/models";
import ProductList from "@/components/Product/List.vue";
import Truncate from "@/filters/Truncate";
import Attachment from "../../models/Attachment";
import { httpStore, currentUserStore } from "@/store/typed";

@Component({
  components: { Page, FileUploader, ProductList },
  filters: { Truncate },
})
export default class FamilyShow extends Mixins(FamiliesMixin) {
  private family: Family = null;

  private newAttachments = [];

  static readonly getFamilytag = "get_family_tag";
  @RegisterHttp(FamilyShow.getFamilytag) getFamilyRequest: RequestData;

  private logo = null;
  private newLogo = null;

  get currentUser() {
    return currentUserStore.user;
  }

  download(attachment: Attachment) {
    const url = attachment.url;
    let a = document.createElement("a");
    a.href = url;
    const fileName = url.split("/").pop();
    a.download = attachment.name;
    document.body.appendChild(a);
    window.open(url);
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  get url() {
    return this.newLogo?.url || this.logo?.url;
  }

  get description() {
    return this.family.descriptionIt;
  }

  get valid() {
    return (
      this.family?.code &&
      this.family?.descriptionIt &&
      this.family?.descriptionEn &&
      this.family?.name
    );
  }

  onEdit() {
    this.$router.push({
      name: "family_edit",
      params: { id: this.$route.params.id },
    });
  }

  isAttachmentLoading(attachment) {
    return httpStore.status[this.detachFileTag(attachment)];
  }

  attachFileTag(file) {
    return `attach_${file.id}_tag`;
  }

  detachFileTag(file) {
    return `detach_${file.id}_tag`;
  }

  detachAttachment(attachment) {
    const tag = this.detachFileTag(attachment);
    this.detachFile(
      { id: this.family.id, attachment_id: attachment.id },
      tag
    ).then((resp) => {
      const index = this.family.attachments.findIndex(
        (o) => o.id === attachment.id
      );

      this.family.attachments.splice(index, 1);
    });
  }

  onFileChange(attachments) {
    for (const attachment of attachments) {
      this.attachAttachment(attachment);
    }
  }

  attachAttachment(attachment) {
    let data = new FormData();
    data.append("id", this.family.id);
    data.append("file", attachment.file);
    const tag = this.attachFileTag(attachment);
    this.attachFile(this.family.id, data, tag).then((resp) => {
      this.family.attachments.unshift(attachment);
    });
  }

  mounted() {
    this.loadFamily();
  }

  loadFamily() {
    this.getFamily(this.$route.params.id, FamilyShow.getFamilytag).then(
      (resp) => {
        this.family = resp;
        this.logo = { url: this.family.iconUrl };
      },
      (err) => {}
    );
  }

  updatePayload() {
    let payload = new FormData();
    for (const key of ["name", "code", "descriptionIt", "descriptionEn"]) {
      payload.append(key, this.family[key]);
    }
    if (this.newLogo) {
      payload.append("icon", this.newLogo.file);
    }

    return payload;
  }
}
